import React from "react";
import "./ScrollDownAnimation.css"; 

const ScrollDownAnimation = () => {
  return (
    <div className="scroll-container">
      <span className="scroll-btn">
        <span className="mouse">
          <span></span>
        </span>
      </span>
    </div>
  );
};

export default ScrollDownAnimation;
